<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-if="dataLoaded" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Pessoa</strong>
          </div>

            <modal-select label="Família" namevar="surname" modal="families-modal" v-validate="'required'" name="family_id" v-bind:readonly="item.id>0" v-bind:item-id="item.family_id" v-bind:item-code="item.family.data.code"  v-bind:item-name="item.family.data.surname" v-on:select-item="selectFamily"  :state="validateState('family_id')"  ></modal-select>
          <b-form-row>
            <b-col md="3">
              <b-form-fieldset label="ID Pessoa">
                <b-form-input type="text" name="compound_key" v-model="item.compound_key" placeholder="ID Pessoa" :state="validateState('compound_key')" readonly></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('email') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="9">
              <b-form-fieldset label="Nome">
                <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('name') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-form-row>

          <b-form-fieldset label="Email">
            <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: false, email:true }" :state="validateState('email')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('email') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Telefone">
            <b-form-input type="text" name="phone" v-model="item.phone" placeholder="Telefone" v-validate="{ required: false }" :state="validateState('phone')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('phone') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-row>
            <b-col md="4">
              <b-form-fieldset label="NIF">
                <b-form-input type="text" name="nif" v-model="item.nif" placeholder="NIF" v-validate="{ required: false }" :state="validateState('nif')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('nif') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Sexo">
                <b-form-select v-model="item.gender" name="gender" class="mb-3" v-validate="{ required: true }" :state="validateState('gender')">
                  <template v-slot:first>
                   <b-form-select-option :value="null" >-- escolha uma opção --</b-form-select-option>
                 </template>
                  <option value="1">Masculino</option>
                  <option value="2">Feminino</option>
                </b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('gender') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
             <b-col md="6" >
              <b-form-fieldset label="Data de Nascimento">
                <b-form-input type="date" name="birth_date" v-model="item.birth_date" placeholder="Data de Nascimento" v-validate="{ required: isBirthDateRequired }" :state="validateState('birth_date')" data-vv-validate-on="change" ></b-form-input>

                <b-form-invalid-feedback>
                  {{ errors.first('birth_date') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-form-row>
          <b-form-fieldset label="Notas / Observações">
            <b-form-textarea type="text" :rows="10" name="notes" v-model="item.notes" placeholder="Notas / Observações" :state="validateState('notes')" data-vv-validate-on="change" ></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('notes') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Estado</strong>
          </div>
          <b-form-fieldset label="Estado">
            <b-form-select v-model="item.state" class="mb-3" name="state"  :options="states.memberStates"  v-validate="{ required: true }" :state="validateState('state')" >
            </b-form-select>
            <b-form-invalid-feedback>
              {{ errors.first('state') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Pais/Filhos">
            <b-form-select  v-model="item.is_parent" class="mb-3" name="is_parent"  :options="states.isParent"  v-validate="{ required: true }" :state="validateState('is_parent')" >
            </b-form-select>
            <b-form-invalid-feedback>
              {{ errors.first('is_parent') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Escalão">
            <b-form-select v-model="item.family_member_type_id"  name="family_member_type_id" :options="memberTypes" class="mb-3"  v-validate="{ required: false }" :state="validateState('family_member_type_id')" >
              <template v-slot:first>
                <b-form-select-option :value="null" >-- Automático --</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback>
              {{ errors.first('family_member_type_id') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
        </b-card>

        <b-card class="mt-3">
          <div slot="header">
            <strong>Histórico</strong>
          </div>
          <b-table striped hover :items="item.history.data" :fields="historyFields"></b-table>
        </b-card>
      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import States from '@/components/Lists.js'

export default {
  name: 'FamiliesEdit',
  props: ['id'],
  data() {
    return {
      url: 'familymembers',
      baseRoute: 'familymembers',
      showTeam: false,
      showPassword: false,
      dataLoaded: false,
      memberTypes: [],
      states: States,
      item: {
        name: '',
        family: {
          data: {
            id: null,
            surname: ''
          }
        },
        history: {
          data: []
        },
        state: 1,
        email: '',
        code: '',
        gender: null
      },
      historyFields: [{
        key: 'activity.data.name',
        label: 'Actividade',
        sortable: true
      }, {
        key: 'year.data.activity_year',
        label: 'Ano',
        sortable: true
      }, {
        key: 'state',
        label: 'Estado',
        sortable: true
      }]
    }
  },
  computed: {
    isBirthDateRequired() {
      if(this.item.is_parent == 1) {
        return false
      }
      return true
    }
  },
  methods: {
    selectFamily(e) {
      if(e.item) {
        console.log(e.item)
        this.item.family_id = e.item.id
        this.item.family.data = e.item
      } else {
        this.item.family_id = null
        this.item.family.data = {id: null, surname:null}
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast('Esta pessoa não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      this.dataLoaded = true
    }

    this.axios.get('familymembertypes/lst').then(response => {
      this.memberTypes = response.data.data
    })
  }
}
</script>
